module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Pixels-c76c9e9b6e09bcce6797f622a0bb1173.svg";